export var EventConstants = {
    TABLE: {
        READY: 'Table.Ready'
    }
};
